import {Card, Input, InputGroup} from "rsuite";
import {TfiSave} from "react-icons/tfi";
import DeviceParameterSyncButton from "../../../../../shared/DeviceParameterSyncButton/DeviceParameterSyncButton";
import {ExternalDevicesUtils} from "../../../ExternalDevices.utils";

const MechanismInfoSection = ({
                                deviceData,
                                deviceId,
                                onChangePlace,
                                onChangeModel,
                                onChangeArticle,
                                loading,
                                onSavePlace,
                                onSaveArticle,
                                onSaveModel,
                                onRefreshDeviceInfo,
                                isAdmin,
                                isMechanismMovement,
                                deviceType,
                                isConnected = true
}) => {
  return (
    <Card
      style={{
        textAlign: 'center',
        opacity: !isConnected ? 1 : (isMechanismMovement() ? 0.5 : 1)
    }}
      className="p-2"
      header="Информация о механизме"
      bordered>
      <div className="row">
        <div className="col-md-12">
          <div className="mb-3">
            <InputGroup>
              <InputGroup.Addon>Артикул</InputGroup.Addon>
              <Input
                size={"md"}
                value={deviceData?.article || ''}
                onChange={onChangeArticle}
              />
              {isAdmin && (
                <InputGroup.Addon>
                  <TfiSave
                    style={{cursor: 'pointer'}}
                    onClick={onSaveArticle}
                    className={loading ? "loading" : ""}
                  />
                </InputGroup.Addon>
              )}
            </InputGroup>
          </div>

          <div className="mb-3">
            <InputGroup>
              <InputGroup.Addon>Дата производства</InputGroup.Addon>
              <Input
                size={"md"}
                value={deviceData?.fabricDate}
              />
            </InputGroup>
          </div>

          <div className="mb-3">
            <InputGroup>
              <InputGroup.Addon>Версия прошивки</InputGroup.Addon>
              <Input
                size={"md"}
                value={deviceData?.firmwareVersion}
              />
              {isAdmin && (
                <DeviceParameterSyncButton
                  deviceId={deviceId}
                  parameter="FirmwareVersion"
                  onSynced={onRefreshDeviceInfo}
                />
              )}
            </InputGroup>
          </div>
        </div>

        <div className="col-md-12">
          <div className="mb-3">
            <InputGroup>
              <InputGroup.Addon>Модель</InputGroup.Addon>
              <Input
                size={"md"}
                value={deviceData?.model || ''}
                onChange={onChangeModel}
              />
              {isAdmin && (
                <InputGroup.Addon>
                  <TfiSave
                    style={{cursor: 'pointer'}}
                    onClick={onSaveModel}
                    className={loading ? "loading" : ""}
                  />
                </InputGroup.Addon>
              )}
            </InputGroup>
          </div>
          <div className="mb-3">
            <InputGroup>
              <InputGroup.Addon>Серийный номер</InputGroup.Addon>
              <Input
                size={"md"}
                value={ExternalDevicesUtils.formatDeviceSerialNumber(deviceData?.serialNumber, deviceType, deviceData?.model)}
              />
            </InputGroup>
          </div>
          <div className="mb-3">
            <InputGroup>
              <InputGroup.Addon>Место установки</InputGroup.Addon>
              <Input
                size={"md"}
                value={deviceData?.place || ''}
                onChange={onChangePlace}
              />
              {isAdmin && (
                <DeviceParameterSyncButton
                  deviceId={deviceId}
                  parameter="Place"
                  onSynced={onRefreshDeviceInfo}
                />
              )}
              <InputGroup.Addon>
                <TfiSave
                  style={{cursor: 'pointer'}}
                  onClick={onSavePlace}
                  className={loading ? "loading" : ""}
                />
              </InputGroup.Addon>
            </InputGroup>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default MechanismInfoSection;
